<template>
  <div class="DetailU">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Detalle de estilista</p>
        <div class="info-u-c">
          <img class="img_user" :src=userStylelist.avatar>
          <div class="info-u">
            <p>{{userStylelist.fullname}}</p>
            <p>{{userStylelist.username}}</p>
            <p>{{userStylelist.phone}}</p>
            <p>Usuario desde jueves 16 julio 2020</p>
          </div>
          <div class="info-ac p-top">
            <!--<button v-if="userStylelist.blocked == false" v-on:click="bloquear(userStylelist)" class="o-b but-r " id="basic-addon1">Bloquear</button>
            <button v-if="userStylelist.blocked == true" v-on:click="desbloquear(userStylelist)" class="o-b but-r " id="basic-addon1">Desbloquear</button>-->
            <button v-if="userStyleRole.id == userRoleProfesional" v-on:click="convertir(userStylelist)" class="o-b btn-f but-b " id="basic-addon1">Convertir en usuario</button>  
          </div>
        </div>
        <div class="b-c">
          <p class="o-b sub-t">Reservaciones realizadas</p>
          <button v-on:click="activeUR = !activeUR" class="f-r btn-t">
            <i v-bind:class="!activeUR ? 'fa-angle-up' : 'fa-angle-down'" class="fa" aria-hidden="true"></i>
            </button>
          <div v-bind:class="{'c-t-info-h-active': activeUR}" class="c-t-info">
            <table class="table table-light m-top">
              <thead>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Servicio</th>
                  <th scope="col">Pago</th>
                  <th scope="col">Estatus</th>
                  <th scope="col">Comentarios</th>
                  <th scope="col">Rating</th>
                </tr>
              </thead>
              <tbody>  
                <tr v-for="(data, index) in userStylelistAppoinment" :key="index" >
                  <td>{{data.date}}</td>
                  <td>{{data.service.name}}</td>
                  <td>${{data.finalAmount}}</td>
                  <td>{{data.statusDescription}}</td>
                  <td><button v-on:click="comentario(data.comment)" class="btn-actions"><img src="@/assets/images/acciones.png" alt="acciones" /></button></td>
                  <td>{{data.rating}}/5</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>

import User from '../parse/models/User'
import Appointment from '../parse/models/Appointment'
import Side from '@/components/Side'
import Nav from '@/components/Nav'

export default {
  name: 'DetailU',
  components: {
  },
  data () {
    return {
      activeUR: true,
      id: this.$route.params.id,
      userStyleRole: [],
      userStylelist: [],
      userStylelistAppoinment: [],
      userRoleProfesional: "4aYcG3DVXG"
    }
  },
  beforeMount() {
    User.detailStylist(this.id).then((user) => {

      this.userStylelist = user
      user.loadRole(this.userStylelist)

      .then(role => { this.userStyleRole = role})
      .catch(error => { console.log(error) })

    })

    Appointment.loadDetailStylist(this.id)
    .then(appointment => { this.userStylelistAppoinment = appointment })
    .catch(error => { console.log(error) })
  },
  methods: {
    convertir(userStylelist){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres convertir al usuario?',
        type: 'warning',
        confirmButtonText: 'Convertir',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if(result.value) {
          this.$swal('', 'Usuario convertido', 'success')
            User.convertStylist(userStylelist)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      })
    },

    
    bloquear(userStylelist){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres bloquear al usuario?',
        type: 'warning',
        confirmButtonText: 'Bloquear',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(result => {
        if(result.value) {
          this.$swal('', 'Usuario bloqueado', 'success')
            User.blocked(userStylelist)
            .then(resultado => this.reload())
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      });
    },

    desbloquear(userStylelist){
      this.$swal({
        title: 'Espera',
        text: '¿Estás seguro de que quieres desbloquear al usuario?',
        type: 'warning',
        confirmButtonText: 'Desbloquear',
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(result => {
        if(result.value) {
          this.$swal('', 'Usuario desbloqueado', 'success')
            User.notblocked(userStylelist)
            .then(resultado => this.reload() )
            .catch(error => console.log(error))
        } else {
          this.$swal('', 'Cancelado', 'info')
        }
      });
    },

    reload(){
      User.detailStylist(this.id).then((user) => {

        this.userStylelist = user
        user.loadRole(this.userStylelist)

        .then(role => { this.userStyleRole = role})
        .catch(error => { console.log(error) })

      })

      Appointment.loadDetailStylist(this.id)
      .then(appointment => { this.userStylelistAppoinment = appointment })
      .catch(error => { console.log(error) })
    },

    comentario(comments){
      console.log(comments)
      this.$swal({
        title: 'Comentario',
        text: comments,
        showCloseButton: false,
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .c-t-info{
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
  }

  .c-t-info-h-active{
    height: auto;
    max-height: 600px;
  }

  /* USER INFO */
  .img_user{
    width: 138px;
    height: 138px;
    border-radius: 70px;
    float: left;
    margin-right: 20px;
  }

  .info-u{
    display: inline;
  }

  .info-ac button{
    display: inline;
  }

  table tbody tr{
    background: #F3F3F3;
  }

  .but-r{
    background: #E96369;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
    font-size: 14px;
  }

  .but-r:hover{ 
    background: rgb(231, 76, 84);
  }


  .but-c{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 270px;
    height: 40px;
    border-radius: 10px;
    font-size: 18px;
  }

  .but-c:hover{ 
    background: #14fc78;
  }
  
  .but-b{
    background: #000;
    color: #fff;
    border: 0;
    width: 200px;
    height: 40px;
    border-radius: 10px;
  }
  .but-b:hover{ 
    background: rgb(27, 27, 27);
  }
  

  .m-r{
    margin-right: 50px;
  }

  .dropdown-menu{
    width: 120px;
  }

  /* Container */
  
  .content-info{
    margin-left: 310px;
    margin-right: 50px;
  }

  .c-i-c{
    width: 235px;
    height: 51px;
    background: #000;
    text-align: center;
    border-radius: 20px;
  }

  .t-u-c{
    padding-top: 14px;
    color: #fff;
    font-size: 16px;
  }

  .b-c {
    margin-right: 50px;
    margin-top: 37px;
    border: 1px solid #f6f6f6;
    -webkit-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    -moz-box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    box-shadow: 0px 3px 5px 0px rgba(151,151,151,1);
    padding: 15px;
  }

  .sub-t{
    font-size: 18px;
    display: inline;
  }

  .i-f-s{
    width: 25px;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .c-f-g{
    background: #f3f3f3;
    border: none;
    padding: 2px;
    height: 40px;
  }

  .but-g{
    background: #85EEB3;
    color: #fff;
    border: 0;
    width: 140px;
    height: 40px;
    border-radius: 10px;
  }
  .but-g:hover{ 
    background: #14fc78;
  }

  .btn-f{
    margin: 0 40px 0 20px;
  }

  .f-r{
    float: right;
  }

  .btn-t{
    background: #fff;
    border: none;
  }

  .s-o{
    background: #f3f3f3;
    border: none;
    font-family: "Open regular";
    font-size: 16px;
    padding: 5px;
  }

  .s-o option{
    padding: 5px;
  }

  .table{
    border: 1px solid #f6f6f6;
    text-align: center;
  }
  .btn-actions{
    background: #f6f6f6;
    border: none;
  }

</style>
